import SaveIcon from '@mui/icons-material/Save';
import { Grid, Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { observer } from 'mobx-react';
import React from 'react';

import { LoadingButton } from '@mui/lab';
import { TranslateText } from '../../../application/language/TranslateText';
import { ICommonProperties } from '../../../common/properties/ICommonProperties';
import { Colors } from '../color/Colors';
import { useI18n } from '../../../application/language/useI18n';

export interface IFormActionsProperties extends ICommonProperties {
  onSave: any;
  onCancel: any;
  onDelete?: any;
  disabled?: boolean;
  isLoading?: boolean;
}

export const FormActions = observer(
  ({ onCancel, onSave, disabled = false, onDelete = null, isLoading = false }: IFormActionsProperties) => {
    const classes = useStyles();
    return (
      <Grid container className={classes.container}>
        <Grid item>
          <LoadingButton
            variant="contained"
            color="secondary"
            className={classes.actionButton}
            onClick={onCancel}
            loading={isLoading}
            disabled={disabled}
          >
            <TranslateText i18nKey='phrases.cancel' />
          </LoadingButton>
          {onDelete && (
            <LoadingButton
              variant="contained"
              color="primary"
              className={classes.actionButton}
              onClick={onDelete}
              disabled={disabled}
              loading={isLoading}
              style={{ color: Colors.negativePassive }}
            >
              <TranslateText i18nKey='phrases.delete' />
            </LoadingButton>
          )}
          <LoadingButton
            variant="contained"
            color="secondary"
            size="large"
            className={classes.actionButton}
            startIcon={<SaveIcon />}
            onClick={onSave}
            disabled={disabled}
            loading={isLoading}
          >
            <TranslateText i18nKey='phrases.save' />
          </LoadingButton>
        </Grid>
      </Grid>
    );
  },
);

export const FormAddButton = observer(
  ({ onSave, disabled = false, isLoading = false, buttonText }) => {
    const { translate } = useI18n()

    const saveButtonText = buttonText || translate('phrases.save')
    return (
      <Grid style={{ marginLeft: '10px' }}>
        <LoadingButton
          style={{
            backgroundColor: `${Colors.greenButtonOpacity('0.7')} `,
            color: 'white'
          }}
          variant="outlined"
          color="success"
          onClick={() => {
            onSave()
          }}
          disabled={disabled}
          loading={isLoading}
        >
          {saveButtonText}
        </LoadingButton>
      </Grid>
    );
  },
);

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    justifyContent: 'flex-end',
  },
  actionButton: {
    margin: theme.spacing(2),
  },
}));
